import { markSingleNotificationAsRead } from "_services/api/user";
import Presentation                     from "./presentation";

const component = props => {

	const {
		activeTab,
		activeUpdateTab,
		marked,
		handleMarkAllRead
	} = props;

	// for marking all notifications read. 1 - read, 0 - unread

	const clickImpression = async data => {
		const params = {
			"impressions": [
				{
					SK               : data?.SK,
					notificationType : data?.payload?.notificationType,
					eventType        : 2
				}
			]
		};

		try {
			await markSingleNotificationAsRead ( params );
		} catch ( e ) {
			return;
		}
	};

	const viewImpression = async data => {
		const params = {
			"impressions": [
				{
					SK               : data?.SK,
					notificationType : data?.payload?.notificationType,
					eventType        : 2
				}
			]
		};

		try {
			await markSingleNotificationAsRead ( params );
		} catch ( e ) {
			return;
		}
	};

	return (
		<Presentation
			activeTab       = { activeTab }
			activeUpdateTab = { activeUpdateTab }
			clickImpression = { clickImpression }
			handleMarkAllRead = { handleMarkAllRead }
			marked          = { marked }
			viewImpression  = { viewImpression }
		/>
	);
};

export default component;
